import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import PageTitle from 'components/_base/PageTitle';

import ContentQuery from './ContentQuery';

const App = () => {
  return (
    <>
      <HeaderApp />
      <PageTitle title="Solicitações em Andamento" />
      <hr />
      <ContentQuery />
      <Bottom />
    </>
  );
};

export default App;
